<template>
  <span>
    <span v-bind:class="{ 'bg-orange': isWordActive(index) }" class="rounded-md" :key="index" v-for="(word, index) in words">
        {{ word }}
        <!-- <i class="absolute h-full w-full block -top-1 opacity-50 -left-1 z-0 p-1 box-content" ></i> -->
    </span>
  </span>
</template>

<script>
export default {
  name: "BookText",
  props: ["text", "highlight"],
  data() {
    return {
      words: [],
    };
  },
  mounted: function mounted() {
    this.words = this.text.split(" ");
  },
  watch: {
    highlight: {
      immediate: true,
      handler(newValue, oldValue) {
      },
    },
  },
  methods: {
    isWordActive(index) {
       return index === this.highlight;
    },
  },
};
</script>